import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dtypeItemHost]',
    standalone: true
})
export class DtypeDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
